import React, { useState } from 'react'
import _ from 'lodash'

import CustomOverlayTrigger from '../widgets/overlay_trigger'

const ELLIPSES = '…'
const SPACE_CHARACTER = ' '
const READ_MORE_LABEL = 'Read More'
const SHOW_LESS_LABEL = 'Show Less'

const ReadMore = ({
  showReadMore = true,
  showLess = true,
  className = '',
  children,
  truncateLength = 100
}) => {
  const originalText = children
  const truncatedText = _.truncate(originalText,
    { 'length': truncateLength, 'omission': '' })

  const [showTruncatedText, setShowTruncatedText] = useState(true)

  const toggleReadMore = (buttonLabel) => {
    let displayText = showTruncatedText
    if (buttonLabel) {
      displayText = buttonLabel === SHOW_LESS_LABEL
    } else {
      displayText = !displayText
    }
    setShowTruncatedText(displayText)
  }

  const getActionElement = () => {
    let buttonLabel = showTruncatedText
      ? showReadMore ? READ_MORE_LABEL : ELLIPSES
      : showLess ? SHOW_LESS_LABEL : ELLIPSES

    let toolTipContent =
      showTruncatedText
        ? READ_MORE_LABEL
        : SHOW_LESS_LABEL


    if (!showLess && !showTruncatedText) {
      return
    }

    return (
      <CustomOverlayTrigger
        className="tooltip-clearout"
        id='co-read-more-or-hide'
        content={toolTipContent}
        placement='bottom'
      >
        <span
          onClick={() => toggleReadMore(buttonLabel)}
          className="read-or-hide"
          data-tip={buttonLabel === ELLIPSES ? 'Read more' : ''}
          data-for='co-read-more-or-hide'
        >
          {buttonLabel}
        </span>
      </CustomOverlayTrigger>
    )
  }

  if (_.size(truncatedText) === _.size(originalText)) {
    return (
      <div className={'CO-read-more-text ' + className}>
        <p className='m-0'>{originalText}</p>
      </div>
    )
  }

  return (
    <div className={'CO-read-more-text ' + className}>
      <div>
        {
          showTruncatedText
            ? truncatedText + SPACE_CHARACTER
            : originalText
        }
        {getActionElement()}
      </div>
    </div>
  )
}

export default ReadMore
